import moment from 'moment'
import InternalLink from '../../../atoms/InternalLink/InternalLink'
import { DATE_FORMAT } from '../../../constants'
import t from '../../../i18n/translations/translations'
import './HartuFacilityCard.css'
import Imagen from '../../../assets/img/Placeholder.png'
import useImageExists from '../../../hooks/useImageExists'
import '@fortawesome/fontawesome-free/css/all.min.css';
import { getCookie, setCookie } from '../../../utils/cookiesFunctions'

const createUrl = (lang, card, date) => {
    const urlDate = date ? moment(date).format(DATE_FORMAT) : null
    return urlDate
        ? `/${lang}/hartu/booking/${card.id}/${urlDate}`
        : `/${lang}/hartu/booking/${card.id}`
}

const goToGiltza = (lang,idinstancia, idFacility) => {
    let idInstancia = idinstancia ? idinstancia : 102;
    
    return`https://giltza.biscaytik.eu/Sender.aspx?lang=${lang}&urlRed=${process.env.REACT_APP_API_URL_BASE}giltza/frontend/validation_user/${idInstancia}/${idFacility}`     
}


function HartuFacilityCard({
    card,
    censed,
    description,
    disability,
    image,
    lang,
    idFacility,
    idinstancia,
    selectedDate,
    canBookButton,
    hasDiscount,
    maxBookingsDay,
    maxBookingsMonth,
    limitBookingsDayReached,
    limitBookingsMonthReached,
    limitInstance,
    limitInstanceName
}) {
    const searchParams = new URLSearchParams(
        window.location.href.split(`?`)[
            window.location.href.split(`?`).length - 1
        ]
    )

    const userCensed = searchParams.get('censed');
    const userId = searchParams.get('sid');
    const userNotCensed = searchParams.get('user_not_censed') === "true";
    const token = searchParams.get('uztk'+idinstancia);
    const sid = sessionStorage.getItem('uzky') ?? null

    if (typeof userId !== 'undefined' && userId !== null) {
        if (typeof token !== 'undefined' && token !== null) {
            sessionStorage.setItem('token', token);
        }

        sessionStorage.setItem('uzky', userId);
        if ( userCensed == "false") {
            location.replace(window.location.origin + window.location.pathname + "?user_not_censed=true")
        } else {
            location.replace(window.location.origin + window.location.pathname)
        }
    }

    const imageExists = useImageExists(image)
    const imageUrl = imageExists ? image : Imagen;

    return (
        <article className="hartuFacilityCard">
            <div className="hartuFacilityCard__top">
                <h3>{card.name[lang]}</h3>
            </div>
            <div
                className="hartuFacilityCard__middle"
                style={{
                    backgroundImage: `url("${imageUrl}")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 250px',
                }}
            >
                <div className="hartuFacilityCard__logo">
                    {censed ? (
                        <div className='hartuFacilityCard__logo-div'>
                            <i aria-hidden="true"
                                className="fa fa-lock lock-icon"
                                title={t.only_census[lang]} />
                        </div>
                    ) : null}
                    {disability ? (
                        <div className='hartuFacilityCard__logo-div'>
                            <i aria-hidden="true"
                                className="fa fa-wheelchair wheelchair-icon"
                                title={t.moviliy_reduced[lang]} />
                        </div>
                    ) : null}
                    {hasDiscount ? (
                        <div className='hartuFacilityCard__logo-div'>
                            <i aria-hidden="true"
                                className="fa fa-percent discount-icon"
                                title={t.has_discount[lang]} />
                        </div>
                    ) : null}
                    {maxBookingsDay == 0 & maxBookingsMonth == 0 ? (
                        <div className='hartuFacilityCard__logo-div'>
                            <i aria-hidden="true"
                                className="fas fa-infinity hartu-infinity-icon"
                                title={t.has_no_limit[lang]} />
                        </div>
                    ) : maxBookingsDay != 0 ?(
                            <div className='hartuFacilityCard__logo-div'>
                            <span 
                                className="hartu-limit-booking-icon"
                                title={t.has_limit_booking[lang]}>
                                    {maxBookingsDay}
                            </span>
                        </div>
                    ) : null}
                </div>

                { !canBookButton.available && (canBookButton.code == 2 || canBookButton.code == 3) ? (
                    <div className="hartuFacilityCard__button">
                        <InternalLink url={goToGiltza(lang, idinstancia, idFacility)}>
                            {canBookButton.message}
                        </InternalLink>
                    </div>
                ) : !canBookButton.available ? (
                    <div className="hartuFacilityCard__button">
                        <InternalLink disabled className="disabled-link">
                            {canBookButton.message}
                        </InternalLink>
                    </div>
                ) : canBookButton.available ? (
                    <div className="hartuFacilityCard__button">
                        <InternalLink url={createUrl(lang, card, selectedDate)}>
                            {canBookButton.message}
                        </InternalLink>
                    </div>
                ) : null}
            </div>
            <div className="hartuFacilityCard__banner">
                {limitBookingsDayReached && limitBookingsMonthReached ? (
                    <div className="hartuFacilityCard__banner_limit">
                        <span>{t.limit_booking_month_day_reached[lang]}</span>
                    </div>
                ) : limitBookingsDayReached ? (
                    <div className="hartuFacilityCard__banner_limit">
                        <span>{t.limit_booking_day_reached[lang]}</span>
                    </div>
                ) : limitBookingsMonthReached ? (
                    <div className="hartuFacilityCard__banner_limit">
                        <span>{t.limit_booking_month_reached[lang]}</span>
                    </div>
                ) : null}
            </div>
            <div className="hartuFacilityCard__bottom">
                <p
                    dangerouslySetInnerHTML={{
                        __html: description[lang],
                    }}
                />
            </div>
        </article>
    )
}

export default HartuFacilityCard
